/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SitemapRouteImport } from './routes/sitemap'
import { Route as RssRouteImport } from './routes/rss'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as MypageRouteImport } from './routes/mypage'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PostsIndexRouteImport } from './routes/posts.index'
import { Route as NewsIndexRouteImport } from './routes/news.index'
import { Route as ArticlesIndexRouteImport } from './routes/articles.index'
import { Route as PostsCreateRouteImport } from './routes/posts.create'
import { Route as NewsLoansRouteImport } from './routes/news.loans'
import { Route as NewsGrantsRouteImport } from './routes/news.grants'
import { Route as NewsFacilitiesRouteImport } from './routes/news.facilities'
import { Route as NewsIdRouteImport } from './routes/news.$id'
import { Route as AuthResetRouteImport } from './routes/auth.reset'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'
import { Route as ArticlesPendingRouteImport } from './routes/articles.pending'
import { Route as ArticlesCreateRouteImport } from './routes/articles.create'
import { Route as ArticlesIdRouteImport } from './routes/articles.$id'
import { Route as AdminArticlesRouteImport } from './routes/admin.articles'
import { Route as PostsIdIndexRouteImport } from './routes/posts.$id.index'
import { Route as NewsProgramsIndexRouteImport } from './routes/news.programs.index'
import { Route as ArticlesIdIndexRouteImport } from './routes/articles.$id.index'
import { Route as PostsIdEditRouteImport } from './routes/posts.$id.edit'
import { Route as NewsProgramsKindRouteImport } from './routes/news.programs.$kind'
import { Route as ArticlesIdEditRouteImport } from './routes/articles.$id.edit'

const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const SitemapRoute = SitemapRouteImport.update({
  id: '/sitemap',
  path: '/sitemap',
  getParentRoute: () => rootRouteImport,
} as any)
const RssRoute = RssRouteImport.update({
  id: '/rss',
  path: '/rss',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const MypageRoute = MypageRouteImport.update({
  id: '/mypage',
  path: '/mypage',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PostsIndexRoute = PostsIndexRouteImport.update({
  id: '/posts/',
  path: '/posts/',
  getParentRoute: () => rootRouteImport,
} as any)
const NewsIndexRoute = NewsIndexRouteImport.update({
  id: '/news/',
  path: '/news/',
  getParentRoute: () => rootRouteImport,
} as any)
const ArticlesIndexRoute = ArticlesIndexRouteImport.update({
  id: '/articles/',
  path: '/articles/',
  getParentRoute: () => rootRouteImport,
} as any)
const PostsCreateRoute = PostsCreateRouteImport.update({
  id: '/posts/create',
  path: '/posts/create',
  getParentRoute: () => rootRouteImport,
} as any)
const NewsLoansRoute = NewsLoansRouteImport.update({
  id: '/news/loans',
  path: '/news/loans',
  getParentRoute: () => rootRouteImport,
} as any)
const NewsGrantsRoute = NewsGrantsRouteImport.update({
  id: '/news/grants',
  path: '/news/grants',
  getParentRoute: () => rootRouteImport,
} as any)
const NewsFacilitiesRoute = NewsFacilitiesRouteImport.update({
  id: '/news/facilities',
  path: '/news/facilities',
  getParentRoute: () => rootRouteImport,
} as any)
const NewsIdRoute = NewsIdRouteImport.update({
  id: '/news/$id',
  path: '/news/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthResetRoute = AuthResetRouteImport.update({
  id: '/auth/reset',
  path: '/auth/reset',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const ArticlesPendingRoute = ArticlesPendingRouteImport.update({
  id: '/articles/pending',
  path: '/articles/pending',
  getParentRoute: () => rootRouteImport,
} as any)
const ArticlesCreateRoute = ArticlesCreateRouteImport.update({
  id: '/articles/create',
  path: '/articles/create',
  getParentRoute: () => rootRouteImport,
} as any)
const ArticlesIdRoute = ArticlesIdRouteImport.update({
  id: '/articles/$id',
  path: '/articles/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminArticlesRoute = AdminArticlesRouteImport.update({
  id: '/admin/articles',
  path: '/admin/articles',
  getParentRoute: () => rootRouteImport,
} as any)
const PostsIdIndexRoute = PostsIdIndexRouteImport.update({
  id: '/posts/$id/',
  path: '/posts/$id/',
  getParentRoute: () => rootRouteImport,
} as any)
const NewsProgramsIndexRoute = NewsProgramsIndexRouteImport.update({
  id: '/news/programs/',
  path: '/news/programs/',
  getParentRoute: () => rootRouteImport,
} as any)
const ArticlesIdIndexRoute = ArticlesIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ArticlesIdRoute,
} as any)
const PostsIdEditRoute = PostsIdEditRouteImport.update({
  id: '/posts/$id/edit',
  path: '/posts/$id/edit',
  getParentRoute: () => rootRouteImport,
} as any)
const NewsProgramsKindRoute = NewsProgramsKindRouteImport.update({
  id: '/news/programs/$kind',
  path: '/news/programs/$kind',
  getParentRoute: () => rootRouteImport,
} as any)
const ArticlesIdEditRoute = ArticlesIdEditRouteImport.update({
  id: '/edit',
  path: '/edit',
  getParentRoute: () => ArticlesIdRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/mypage': typeof MypageRoute
  '/onboarding': typeof OnboardingRoute
  '/privacy': typeof PrivacyRoute
  '/rss': typeof RssRoute
  '/sitemap': typeof SitemapRoute
  '/terms': typeof TermsRoute
  '/admin/articles': typeof AdminArticlesRoute
  '/articles/$id': typeof ArticlesIdRouteWithChildren
  '/articles/create': typeof ArticlesCreateRoute
  '/articles/pending': typeof ArticlesPendingRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/reset': typeof AuthResetRoute
  '/news/$id': typeof NewsIdRoute
  '/news/facilities': typeof NewsFacilitiesRoute
  '/news/grants': typeof NewsGrantsRoute
  '/news/loans': typeof NewsLoansRoute
  '/posts/create': typeof PostsCreateRoute
  '/articles/': typeof ArticlesIndexRoute
  '/news/': typeof NewsIndexRoute
  '/posts/': typeof PostsIndexRoute
  '/articles/$id/edit': typeof ArticlesIdEditRoute
  '/news/programs/$kind': typeof NewsProgramsKindRoute
  '/posts/$id/edit': typeof PostsIdEditRoute
  '/articles/$id/': typeof ArticlesIdIndexRoute
  '/news/programs/': typeof NewsProgramsIndexRoute
  '/posts/$id/': typeof PostsIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/mypage': typeof MypageRoute
  '/onboarding': typeof OnboardingRoute
  '/privacy': typeof PrivacyRoute
  '/rss': typeof RssRoute
  '/sitemap': typeof SitemapRoute
  '/terms': typeof TermsRoute
  '/admin/articles': typeof AdminArticlesRoute
  '/articles/create': typeof ArticlesCreateRoute
  '/articles/pending': typeof ArticlesPendingRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/reset': typeof AuthResetRoute
  '/news/$id': typeof NewsIdRoute
  '/news/facilities': typeof NewsFacilitiesRoute
  '/news/grants': typeof NewsGrantsRoute
  '/news/loans': typeof NewsLoansRoute
  '/posts/create': typeof PostsCreateRoute
  '/articles': typeof ArticlesIndexRoute
  '/news': typeof NewsIndexRoute
  '/posts': typeof PostsIndexRoute
  '/articles/$id/edit': typeof ArticlesIdEditRoute
  '/news/programs/$kind': typeof NewsProgramsKindRoute
  '/posts/$id/edit': typeof PostsIdEditRoute
  '/articles/$id': typeof ArticlesIdIndexRoute
  '/news/programs': typeof NewsProgramsIndexRoute
  '/posts/$id': typeof PostsIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/mypage': typeof MypageRoute
  '/onboarding': typeof OnboardingRoute
  '/privacy': typeof PrivacyRoute
  '/rss': typeof RssRoute
  '/sitemap': typeof SitemapRoute
  '/terms': typeof TermsRoute
  '/admin/articles': typeof AdminArticlesRoute
  '/articles/$id': typeof ArticlesIdRouteWithChildren
  '/articles/create': typeof ArticlesCreateRoute
  '/articles/pending': typeof ArticlesPendingRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/reset': typeof AuthResetRoute
  '/news/$id': typeof NewsIdRoute
  '/news/facilities': typeof NewsFacilitiesRoute
  '/news/grants': typeof NewsGrantsRoute
  '/news/loans': typeof NewsLoansRoute
  '/posts/create': typeof PostsCreateRoute
  '/articles/': typeof ArticlesIndexRoute
  '/news/': typeof NewsIndexRoute
  '/posts/': typeof PostsIndexRoute
  '/articles/$id/edit': typeof ArticlesIdEditRoute
  '/news/programs/$kind': typeof NewsProgramsKindRoute
  '/posts/$id/edit': typeof PostsIdEditRoute
  '/articles/$id/': typeof ArticlesIdIndexRoute
  '/news/programs/': typeof NewsProgramsIndexRoute
  '/posts/$id/': typeof PostsIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/mypage'
    | '/onboarding'
    | '/privacy'
    | '/rss'
    | '/sitemap'
    | '/terms'
    | '/admin/articles'
    | '/articles/$id'
    | '/articles/create'
    | '/articles/pending'
    | '/auth/callback'
    | '/auth/reset'
    | '/news/$id'
    | '/news/facilities'
    | '/news/grants'
    | '/news/loans'
    | '/posts/create'
    | '/articles/'
    | '/news/'
    | '/posts/'
    | '/articles/$id/edit'
    | '/news/programs/$kind'
    | '/posts/$id/edit'
    | '/articles/$id/'
    | '/news/programs/'
    | '/posts/$id/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/mypage'
    | '/onboarding'
    | '/privacy'
    | '/rss'
    | '/sitemap'
    | '/terms'
    | '/admin/articles'
    | '/articles/create'
    | '/articles/pending'
    | '/auth/callback'
    | '/auth/reset'
    | '/news/$id'
    | '/news/facilities'
    | '/news/grants'
    | '/news/loans'
    | '/posts/create'
    | '/articles'
    | '/news'
    | '/posts'
    | '/articles/$id/edit'
    | '/news/programs/$kind'
    | '/posts/$id/edit'
    | '/articles/$id'
    | '/news/programs'
    | '/posts/$id'
  id:
    | '__root__'
    | '/'
    | '/about'
    | '/mypage'
    | '/onboarding'
    | '/privacy'
    | '/rss'
    | '/sitemap'
    | '/terms'
    | '/admin/articles'
    | '/articles/$id'
    | '/articles/create'
    | '/articles/pending'
    | '/auth/callback'
    | '/auth/reset'
    | '/news/$id'
    | '/news/facilities'
    | '/news/grants'
    | '/news/loans'
    | '/posts/create'
    | '/articles/'
    | '/news/'
    | '/posts/'
    | '/articles/$id/edit'
    | '/news/programs/$kind'
    | '/posts/$id/edit'
    | '/articles/$id/'
    | '/news/programs/'
    | '/posts/$id/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AboutRoute: typeof AboutRoute
  MypageRoute: typeof MypageRoute
  OnboardingRoute: typeof OnboardingRoute
  PrivacyRoute: typeof PrivacyRoute
  RssRoute: typeof RssRoute
  SitemapRoute: typeof SitemapRoute
  TermsRoute: typeof TermsRoute
  AdminArticlesRoute: typeof AdminArticlesRoute
  ArticlesIdRoute: typeof ArticlesIdRouteWithChildren
  ArticlesCreateRoute: typeof ArticlesCreateRoute
  ArticlesPendingRoute: typeof ArticlesPendingRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  AuthResetRoute: typeof AuthResetRoute
  NewsIdRoute: typeof NewsIdRoute
  NewsFacilitiesRoute: typeof NewsFacilitiesRoute
  NewsGrantsRoute: typeof NewsGrantsRoute
  NewsLoansRoute: typeof NewsLoansRoute
  PostsCreateRoute: typeof PostsCreateRoute
  ArticlesIndexRoute: typeof ArticlesIndexRoute
  NewsIndexRoute: typeof NewsIndexRoute
  PostsIndexRoute: typeof PostsIndexRoute
  NewsProgramsKindRoute: typeof NewsProgramsKindRoute
  PostsIdEditRoute: typeof PostsIdEditRoute
  NewsProgramsIndexRoute: typeof NewsProgramsIndexRoute
  PostsIdIndexRoute: typeof PostsIdIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sitemap': {
      id: '/sitemap'
      path: '/sitemap'
      fullPath: '/sitemap'
      preLoaderRoute: typeof SitemapRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rss': {
      id: '/rss'
      path: '/rss'
      fullPath: '/rss'
      preLoaderRoute: typeof RssRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mypage': {
      id: '/mypage'
      path: '/mypage'
      fullPath: '/mypage'
      preLoaderRoute: typeof MypageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/posts/': {
      id: '/posts/'
      path: '/posts'
      fullPath: '/posts/'
      preLoaderRoute: typeof PostsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/news/': {
      id: '/news/'
      path: '/news'
      fullPath: '/news/'
      preLoaderRoute: typeof NewsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/articles/': {
      id: '/articles/'
      path: '/articles'
      fullPath: '/articles/'
      preLoaderRoute: typeof ArticlesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/posts/create': {
      id: '/posts/create'
      path: '/posts/create'
      fullPath: '/posts/create'
      preLoaderRoute: typeof PostsCreateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/news/loans': {
      id: '/news/loans'
      path: '/news/loans'
      fullPath: '/news/loans'
      preLoaderRoute: typeof NewsLoansRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/news/grants': {
      id: '/news/grants'
      path: '/news/grants'
      fullPath: '/news/grants'
      preLoaderRoute: typeof NewsGrantsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/news/facilities': {
      id: '/news/facilities'
      path: '/news/facilities'
      fullPath: '/news/facilities'
      preLoaderRoute: typeof NewsFacilitiesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/news/$id': {
      id: '/news/$id'
      path: '/news/$id'
      fullPath: '/news/$id'
      preLoaderRoute: typeof NewsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/reset': {
      id: '/auth/reset'
      path: '/auth/reset'
      fullPath: '/auth/reset'
      preLoaderRoute: typeof AuthResetRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/articles/pending': {
      id: '/articles/pending'
      path: '/articles/pending'
      fullPath: '/articles/pending'
      preLoaderRoute: typeof ArticlesPendingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/articles/create': {
      id: '/articles/create'
      path: '/articles/create'
      fullPath: '/articles/create'
      preLoaderRoute: typeof ArticlesCreateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/articles/$id': {
      id: '/articles/$id'
      path: '/articles/$id'
      fullPath: '/articles/$id'
      preLoaderRoute: typeof ArticlesIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/articles': {
      id: '/admin/articles'
      path: '/admin/articles'
      fullPath: '/admin/articles'
      preLoaderRoute: typeof AdminArticlesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/posts/$id/': {
      id: '/posts/$id/'
      path: '/posts/$id'
      fullPath: '/posts/$id/'
      preLoaderRoute: typeof PostsIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/news/programs/': {
      id: '/news/programs/'
      path: '/news/programs'
      fullPath: '/news/programs/'
      preLoaderRoute: typeof NewsProgramsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/articles/$id/': {
      id: '/articles/$id/'
      path: '/'
      fullPath: '/articles/$id/'
      preLoaderRoute: typeof ArticlesIdIndexRouteImport
      parentRoute: typeof ArticlesIdRoute
    }
    '/posts/$id/edit': {
      id: '/posts/$id/edit'
      path: '/posts/$id/edit'
      fullPath: '/posts/$id/edit'
      preLoaderRoute: typeof PostsIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/news/programs/$kind': {
      id: '/news/programs/$kind'
      path: '/news/programs/$kind'
      fullPath: '/news/programs/$kind'
      preLoaderRoute: typeof NewsProgramsKindRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/articles/$id/edit': {
      id: '/articles/$id/edit'
      path: '/edit'
      fullPath: '/articles/$id/edit'
      preLoaderRoute: typeof ArticlesIdEditRouteImport
      parentRoute: typeof ArticlesIdRoute
    }
  }
}

interface ArticlesIdRouteChildren {
  ArticlesIdEditRoute: typeof ArticlesIdEditRoute
  ArticlesIdIndexRoute: typeof ArticlesIdIndexRoute
}

const ArticlesIdRouteChildren: ArticlesIdRouteChildren = {
  ArticlesIdEditRoute: ArticlesIdEditRoute,
  ArticlesIdIndexRoute: ArticlesIdIndexRoute,
}

const ArticlesIdRouteWithChildren = ArticlesIdRoute._addFileChildren(
  ArticlesIdRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  MypageRoute: MypageRoute,
  OnboardingRoute: OnboardingRoute,
  PrivacyRoute: PrivacyRoute,
  RssRoute: RssRoute,
  SitemapRoute: SitemapRoute,
  TermsRoute: TermsRoute,
  AdminArticlesRoute: AdminArticlesRoute,
  ArticlesIdRoute: ArticlesIdRouteWithChildren,
  ArticlesCreateRoute: ArticlesCreateRoute,
  ArticlesPendingRoute: ArticlesPendingRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  AuthResetRoute: AuthResetRoute,
  NewsIdRoute: NewsIdRoute,
  NewsFacilitiesRoute: NewsFacilitiesRoute,
  NewsGrantsRoute: NewsGrantsRoute,
  NewsLoansRoute: NewsLoansRoute,
  PostsCreateRoute: PostsCreateRoute,
  ArticlesIndexRoute: ArticlesIndexRoute,
  NewsIndexRoute: NewsIndexRoute,
  PostsIndexRoute: PostsIndexRoute,
  NewsProgramsKindRoute: NewsProgramsKindRoute,
  PostsIdEditRoute: PostsIdEditRoute,
  NewsProgramsIndexRoute: NewsProgramsIndexRoute,
  PostsIdIndexRoute: PostsIdIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
